import { fixtureKickoff } from "./dayFixtureWorkflow";
import { compareLeagueSelection } from "./leagueSelection";

import { dateKey, calendarDate, berlinDay, today } from "./gamesCalendar";
export { dateKey, calendarDate, berlinDay, today, addDays, weekSection, adjacentSection } from "./gamesCalendar";

export function initialFixtureDay(search = window.location.search) {
  const raw = new URLSearchParams(search).get("date") || "";
  return (
    calendarDate(
      /^\d{8}$/.test(raw)
        ? `${raw.slice(4)}-${raw.slice(2, 4)}-${raw.slice(0, 2)}`
        : raw
    ) || today()
  );
}
export function fixtureInRange(fixture, start, end) {
  const time = fixtureKickoff(fixture);
  if (!Number.isFinite(time)) return false;
  const day = berlinDay(new Date(time));
  return day >= dateKey(start) && day <= dateKey(end);
}
export function sortGames(fixtures, mode, leagues = []) {
  const ordered = [...leagues].sort(compareLeagueSelection),
    rank = new Map(ordered.map((l, i) => [Number(l.id), i]));
  return [...fixtures].sort((a, b) => {
    if (mode === "week" && Number(a.league_id) !== Number(b.league_id))
      return (
        (rank.get(Number(a.league_id)) ?? Infinity) -
          (rank.get(Number(b.league_id)) ?? Infinity) ||
        String(a.league?.name || a.league_id).localeCompare(
          String(b.league?.name || b.league_id),
          undefined,
          { numeric: true }
        )
      );
    return fixtureKickoff(a) - fixtureKickoff(b) || Number(a.id) - Number(b.id);
  });
}
